<template>
  <div class="card mb-4">
    <div class="card-header pb-0 px-3">
      <div class="row">
        <div class="col-md-6">
          <h6 class="mb-0">
            {{ title }}
          </h6>
        </div>
        <div class="col-md-6 d-flex justify-content-end align-items-center">
          <i
            class="far fa-calendar-alt me-2"
            aria-hidden="true"
          />
          <small>Gesamter Zeitraum</small>
        </div>
      </div>
    </div>
    <div class="card-body pt-4 p-3">
      <form
        role="form"
        action="#"
        class="row mb-3"
        @submit.prevent="addSubmit"
      >
        <div class="col-8 col-lg mb-3">
          <material-input
            id="name"
            v-model="form.name"
            variant="static"
            label="Bezeichnung"
            placeholder=""
          />
        </div>
        <div class="col-4 col-lg-2 order-lg-3 mb-3">
          <material-input
            id="amount"
            v-model.number="form.amount"
            variant="static"
            label="Betrag"
            placeholder="Betrag"
            type="number"
            step="any"
          />
        </div>
        <div class="col-8 col-lg-4 mb-3">
          <div
            class="input-group input-group-static"
          >
            <label>Kategorie</label>
            <select
              id="expenseCategory"
              v-model="form.category"
              class="form-control"
              name="expenseCategory"
            />
          </div>
        </div>
        <div class="col-4 col-lg-auto order-lg-4 mb-3">
          <material-button
            class="w-100 h-100"
            color="dark"
            variant="outline"
            size="sm"
          >
            <i class="material-icons text-lg">add_circle</i>
          </material-button>
        </div>
      </form>

      <div
        v-for="(element) in expenses_categories"
        :key="element"
      >
        <h6 class="text-uppercase text-body text-xs font-weight-bolder mb-1 mt-3">
          {{ element }}
        </h6>
        <ul class="list-group">
          <li
            v-for="(expense) in filteredExpenses(element)"
            :key="expense.did"
            class="list-group-item border-0 d-flex justify-content-between ps-0 mb-2 border-radius-lg"
          >
            <div class="d-flex align-items-center">
              <material-button
                :color="expense.amount == 0 ? 'dark' : (expense.amount > 0 ? 'success' : 'danger')"
                variant="outline"
                size="sm"
                class="btn-icon-only btn-rounded mb-0 me-3 d-flex align-items-center justify-content-center finance-row"
                @click="deleteEntry(expense)"
              >
                <i
                  :class="'fas ' + (expense.amount == 0 ? 'fa-exclamation' : (expense.amount > 0 ? 'fa-arrow-up' : 'fa-arrow-down'))"
                  aria-hidden="true"
                />
                <i
                  :class="'fas fa-times text-sm'"
                  aria-hidden="true"
                />
              </material-button>
              <div class="d-flex flex-column">
                <h6 class="mb-1 text-dark text-sm">
                  {{ expense.name }}
                </h6>
                <span class="text-xs">{{ formatDate(expense.createdAt) }}</span>
              </div>
            </div>
            <div
              :class="'d-flex align-items-center text-' + (expense.amount == 0 ? 'dark' : (expense.amount > 0 ? 'success text-gradient' : 'danger text-gradient')) + ' text-sm font-weight-bold'"
            >
              {{ formatter.format(expense.amount) }}
            </div>
          </li>
        </ul>
      </div>
      <ul class="list-group">
        <hr class="my-3 horizontal dark">
        <li
          class="list-group-item border-0 d-flex justify-content-between ps-0 mb-2 border-radius-lg"
        >
          <div class="d-flex align-items-center">
            <material-button
              color="success"
              variant="outline"
              size="sm"
              class="btn-icon-only btn-rounded mb-0 me-3 d-flex align-items-center justify-content-center"
            >
              <i
                class="fas fa-arrow-up"
                aria-hidden="true"
              />
            </material-button>
            <div class="d-flex flex-column">
              <h6 class="mb-0 text-dark text-sm">
                Gesamt
              </h6>
            </div>
          </div>
          <div
            class="d-flex align-items-center text-success text-gradient text-sm font-weight-bold"
          >
            {{ formatter.format(sum) }}
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import * as Choices from "choices.js";
import MaterialButton from "@/components/MaterialButton.vue";
import MaterialInput from "@/components/MaterialInput.vue";

import { db, doc, getDoc, addDoc, collection, updateDoc, query, where, onSnapshot, deleteDoc, orderBy } from "@/firebase";
import moment from 'moment';

export default {
  name: "ExpensesCard",
  components: {
    MaterialButton,
    MaterialInput
  },
  props: {
    title: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    form: {
      name: "",
      category: "",
      amount: 0
    },
    expenses: [],
    expense_categories: [],
    unsubscribe: null,
    formatter: null
  }),
  computed: {
    sum() {
      let sum = 0;
      this.expenses.forEach((expense) => {
        sum += expense.amount;
      });
      return sum;
    }
  },
  async beforeMount() {
    this.formatter = new Intl.NumberFormat('de-DE', {
      style: 'currency',
      currency: 'EUR',
    });

    if (this.$user) {
      const userDocRef = doc(db, 'users', this.$user.uid);
      let userDocSnap = await getDoc(userDocRef);
      this.userDoc = userDocSnap.data();

      this.expenses_categories = this.userDoc.expenses_categories.split(',');

      let q = query(collection(db, "expenses"), where("user", "==", this.$user.uid), orderBy('createdAt'));
      this.unsubscribe = onSnapshot(q, (snapshot) => {
        snapshot.docChanges().forEach((change) => {
          const { newIndex, oldIndex, doc, type } = change
          if (type === 'added') {
            this.expenses.splice(newIndex, 0, doc.data())
          } else if (type === 'modified') {
            this.expenses.splice(oldIndex, 1)
            this.expenses.splice(newIndex, 0, doc.data())
          } else if (type === 'removed') {
            this.expenses.splice(oldIndex, 1)
          }
        });
      }, (error) => {
        console.error(error);
      });

      if (document.getElementById("expenseCategory")) {
        var expenseCategory = document.getElementById("expenseCategory");
        let categories = [];

        let self = this;

        this.userDoc.expenses_categories.split(',').forEach((element, i) => {

          if(i == 0)
            self.form.category = element;

          categories.push({
            value: element,
            label: element,
            selected: (i == 0 ? true : false),
            disabled: false,
          })
        });

        new Choices(expenseCategory, {
          choices: categories,
          classNames: {
            containerInner: 'choices__inner pb-0',
          },
          addItemText: (value) => {
          return `Drücke 'Enter' um <b>"${value}"</b> hinzuzufügen.`;
          },
          maxItemText: (maxItemCount) => {
            return `Maximal ${maxItemCount} können hinzugefügt werden.`;
          },
        });
      }
    }
  },
  async beforeUnmount() {
    this.unsubscribe();
  },
  methods: {
    async addSubmit() {
      let self = this;

      await addDoc(collection(db, "expenses"),       
      {
        ...self.form,
        createdAt: moment().valueOf(),
        user: self.$user.uid
      }).then(async docRef => {
        await updateDoc(docRef, {
          did: docRef.id
        });
      });
    },
    async deleteEntry(expense) {
      await deleteDoc(doc(db, "expenses", expense.did));
    },
    formatDate(timestamp) {
      moment.locale('de');
      return moment(timestamp).format('DD. MMMM YYYY') + ' um ' + moment(timestamp).format('HH:mm');
    },
    filteredExpenses: function (category) {
      return this.expenses.filter(i => i.category === category)
    }
  }
};
</script>

<style lang="scss">
.finance-row {
  .fas {
    &:first-child {
      display: block;   
    }
    &:last-child {
      display: none;
    }
  }
  transition: all ease-in-out 0.25s;

  &:hover {
    .fas {
      &:first-child {
        display: none;
      }
      &:last-child {
        display: block;
      }
    }

    color: #f44335 !important;
    border-color: #f44335 !important;
  }
}
</style>